<template>
  <v-app>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="3" lg="3">
          <v-card elevation="0">

            <v-img src="../assets/isbb.jpg" alt="Fedorae Education Log" contain height="150"></v-img>

            <div class="text-center">
              <!-- <h3 class="mb-2">ISBB CAMBODIA</h3> -->
            </div>
            <v-card-text>
              <v-form ref="form" v-model="hidden" lazy-validation>
                <v-text-field v-model="email" :rules="emailRules" @blur="resetValidation" outlined label="Username"
                  placeholder="john@example.com" :hide-details="hidden" class="mb-3"></v-text-field>
                <v-text-field v-model="password" :rules="passwordRules" @blur="resetValidation" outlined
                  :type="isPasswordVisible ? 'text' : 'password'" label="Password" placeholder="············"
                  :hide-details="hidden"></v-text-field>

                <v-btn block style="background-color:#8a31e2;color:white"  large class="mt-6" @click="loginUser()" :loading="isLoading">
                  {{ text_login }}
                </v-btn>

              </v-form>

              <v-alert dense outlined type="error" v-model="checked_error" class="mt-2 text-caption text-center">
                {{ alert_title }}
              </v-alert>

            </v-card-text>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mdiFacebook, mdiGoogle, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import axios from 'axios'
export default {

  name: 'app-login',
  setup() {
    const isPasswordVisible = ref(false)
    const email = ref('')
    const password = ref('')
    const socialLink = [
      {
        icon: mdiFacebook,
        color: '#4267b2',
        colorInDark: '#4267b2',
      },
      // {
      //   icon: mdiTwitter,
      //   color: '#1da1f2',
      //   colorInDark: '#1da1f2',
      // },
      // {
      //   icon: mdiGithub,
      //   color: '#272727',
      //   colorInDark: '#fff',
      // },
      {
        icon: mdiGoogle,
        color: '#db4437',
        colorInDark: '#db4437',
      },
    ]

    return {

      isPasswordVisible,
      email,
      password,
      socialLink,

      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
  data: () => ({

    text_user: '',
    text_pass: '',
    isLoading: false,
    errors: [],

    emailRules: [
      v => !!v || 'Enter your username',



    ],
    passwordRules: [

      v => !!v || 'Enter your password',

    ],
    checked_error: false,
    alert_title: '',
    valid: false,
    text_login: 'Login',
    hidden: false,
    overlay: false,
  }),
  mounted() {

 

  },
  watch: {
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 3000)
    },
  },
  methods: {

    validate() {

      this.$refs.form.validate()

    },


    resetValidation() {

      this.$refs.form.resetValidation()


    },

    loginUser() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.validate()
        console.log(isValid)

      } else {

        this.isLoading = true
        //this.text_login='Login....'
        var bodyFormData = new FormData();
        bodyFormData.append('username', this.email);
        bodyFormData.append('password', this.password);
        axios.post('http://api.isbbcambodia.org/isbb/public/api/login', bodyFormData).then((data) => {

          var hasErorrsProperty = Object.prototype.hasOwnProperty.call(data.data, "errors");

          if (hasErorrsProperty) {
            this.errors = data.data.errors.message[0];
            this.checked_error = true;
            this.text_login = 'Login'

            data.data.errors.message.forEach((v, i) => {
              this.alert_title += v;
            });

            // this.alert_title=data.data.errors.message[0];
            this.isLoading = false


          } else {
            this.$store.commit("setAuthentication", true);
            this.$router.push({ name: "dashboard" });
            window.localStorage.setItem('info', JSON.stringify(data.data))
            window.localStorage.setItem('hasLogin', true)



          }



        }).catch((error) => {


          // this.errors = error.response.data.errors;
          this.checked_error = true;
          this.text_login = 'Login'
          this.alert_title = "គណនីប្រើប្រាស់មិនមាននៅក្នុង ISBBB";
          this.isLoading = false

        })

      }

    }
  }
}
</script>
<style lang="css" scoped>

</style>